const deglawyPath = '/deglawy';
export const getDeglawyContentById = (id: number) => `${deglawyPath}/content/${id}`;
export const getDeglawyAbout = `${deglawyPath}/about`;
export const getDeglawyEzFinace = `${deglawyPath}/ezFinance`;
export const getDeglawyContents = `${deglawyPath}/content`;
export const updateDeglawyContent = `${deglawyPath}/content`;
export const getDeglawyPartners = `${deglawyPath}/partners`;
export const getDeglawyOffers = `${deglawyPath}/offers`;
